import React from 'react';
import { injectIntl } from 'react-intl';
import { LayoutWithStepper } from 'layouts';
// import {
//   isMobileSafari, isIOS,
// } from 'react-device-detect';
import {
  Button, PageContentWrapper, PaymentDetail, PCardContainer, FooterAction,
  Typography,
  Modal,
} from 'components';
import { stepAction, catalogueAction, applicantAction } from 'shared/store/actions';
// import KnetLogo from 'assets/icons/knet-logo.png';
import apiRequest from 'shared/services/api';
// import { v4 as uuidv4 } from 'uuid';
// import classNames from 'classnames';
import selectors from 'shared/store/selectors';
import { connect } from 'react-redux';
// import { toast } from 'react-toastify';
import { PATH } from 'shared/constant';
import utils from 'shared/helpers/utils';
import { get } from 'lodash';
import Axios from 'axios';

function Payment({
  intl, token, history, investUnitToAmount, onGetStepsProgress, onUpdateCurrentStep,
  catalog, product, onGetCatalogue,
  // onUpdateHistory,
  isShowSubcription, applicantId,
  proofOfTransfer, onSaveProofOfConcept,
}) {
  // const FORSA_ID = 'NWM00033';
  // const ISLAMIC_ID = 'NWM00017';
  const [isPaid, setIsPaid] = React.useState(false);
  // const [disablePayment, setDisablePayment] = React.useState(false);
  // const uuid = uuidv4(); // temporary only
  // const payOnlineClasses = classNames({
  //   'pcard-container--payOnline': true,
  //   'pcard-container--disabled': isPaid,
  // });
  const [fileProof, setFileProof] = React.useState(null);
  const [showWarning, setShowWarning] = React.useState(false);

  React.useEffect(() => {
    if (!isShowSubcription) history.push(PATH.PRINT_CHECKLIST);
  }, [isShowSubcription, history]);

  React.useEffect(() => {
    onUpdateCurrentStep('step6');
    onGetStepsProgress();
  }, [onUpdateCurrentStep, onGetStepsProgress]);

  React.useEffect(() => {
    if (!catalog.length) onGetCatalogue();
  }, [catalog, onGetCatalogue]);

  React.useEffect(() => {
    const getPHistory = async () => {
      try {
        const res = await apiRequest.getPaymentHistory(token);
        if (res && Array.isArray(res) && res.length) {
          const getLatestPaymentItem = res.reduce((a, b) => (a.paidOn > b.paidOn ? a : b));
          const ispaidAlready = getLatestPaymentItem.status === 'CAPTURED';
          setIsPaid(ispaidAlready);
        }
      } catch (err) {
        console.error(err);
      }
    };
    getPHistory();
  }, [token]);

  const getBankDetails = React.useMemo(() => {
    const getSelectedProduct = Array.from([...catalog]).find(item => item.id === product);
    let bankData = [];
    if (getSelectedProduct !== undefined && Object.keys(getSelectedProduct).length) {
      const { bankDetails } = getSelectedProduct;
      bankData = [
        { label: 'Bank', value: get(bankDetails, 'name') },
        { label: 'Swift Code', value: get(bankDetails, 'swift') },
        { label: 'Account Name', value: get(bankDetails, 'accountName') },
        { label: 'Account No.', value: get(bankDetails, 'accountNo') },
        { label: 'IBAN', value: get(bankDetails, 'iban') },
      ];
    }
    return bankData;
  }, [product, catalog]);

  // const onHandlePayment = async (e) => {
  //   e.preventDefault();
  //   setDisablePayment(true);

  //   const successUrl = process.env.REACT_APP_PAYMENT_SUCCESS;
  //   const failUrl = process.env.REACT_APP_PAYMENT_FAIL;
  //   const catalogCopy = [...catalog];
  //   const getSelectedProduct = catalogCopy.find(item => item.id === product);
  //   const investedAmountValue = investUnitToAmount;
  //   // const investedAmountValue = product === FORSA_ID || product === ISLAMIC_ID ? investUnitToAmount : investedAmount.replaceAll(',', '');
  //   try {
  //     // record history on MO
  //     const code = 'NW-PMT-INT';
  //     const codeI18n = 'nw.markaz.middle_office.action_type.payment_started';
  //     onUpdateHistory(code, codeI18n);

  //     const tempData = {
  //       amount: investedAmountValue,
  //       currency: 'KWD',
  //       failureUrl: failUrl,
  //       responseUrl: successUrl,
  //       variable1: getSelectedProduct.id,
  //       variable2: getSelectedProduct.bankDetails?.iban,
  //       variable3: 'KWD',
  //     };
  //     const res = await apiRequest.sendPaymentRequest(token, uuid, tempData);

  //     if (isIOS || isMobileSafari) {
  //       window.location.assign(res);
  //     } else {
  //       window.open(res, '_self');
  //     }

  //     setDisablePayment(false);
  //   } catch (err) {
  //     setDisablePayment(false);
  //     console.error(err);
  //     toast.error('Oops, something went wrong. Please try again later.');
  //   }
  // };

  const handleFileChange = (e) => {
    setFileProof(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!fileProof) {
      alert('Please select a file first!');
      return;
    }

    const formData = new FormData();
    formData.append('file', fileProof);

    try {
      const endpoint = `${process.env.REACT_APP_SMART_CLIENT_DATA}/applicant/${applicantId}/proof_of_transfer`;
      const response = await Axios.post(endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });
      onSaveProofOfConcept(response.data?.proofOfTransfer);
      console.log(response.data);
    } catch (error) {
      console.error('Error uploading the file', error);
    }
  };

  // const manageAountToBeDisplayed = React.useMemo(() => {
  //   const value = product === FORSA_ID || product === ISLAMIC_ID ? investUnitToAmount : investedAmount.replaceAll(',', '');
  //   return value;
  // }, [investedAmount, product, investUnitToAmount]);

  const onManageContinue = () => {
    if (proofOfTransfer === '') {
      setShowWarning(true);
    } else {
      history.push(PATH.PRINT_CHECKLIST);
    }
  };

  const downloadLink = `data:application/octet-stream;base64,${proofOfTransfer}`;

  const footer = (
    <FooterAction
      isSingleButton
      rightButton={intl.formatMessage({ id: 'payment.contiueToLegalDocs' })}
      isDisabled={false}
      onRightButtonClick={onManageContinue}
    />
  );

  return (
    <PageContentWrapper isWithPadding>
      <div className="content-container content-container--withPadding">
        <p className="content-container__para">{intl.formatMessage({ id: 'payment.desc' })}</p>

        <PCardContainer className="pcard-container--amountInvesting">
          <small>{intl.formatMessage({ id: isPaid ? 'payment.amtPaid' : 'payment.investedAmt.label' })}</small>
          <strong>{intl.formatMessage({ id: 'payment.investedAmt' }, { currency: 'KWD', value: utils.formatNumberToDecimal(investUnitToAmount) })}</strong>
          {/* <strong>{intl.formatMessage({ id: 'payment.investedAmt' }, { currency: 'KWD', value: utils.formatNumberToDecimal(investedAmount.replaceAll(',', '')) })}</strong> */}
        </PCardContainer>

        {/* <PCardContainer className={payOnlineClasses}>
          <div className="payOnline">
            <h5>{intl.formatMessage({ id: 'payment.transferNowWith' })}</h5>

            <p>
              <img src={KnetLogo} width={40} alt="KNET" />
              <span>KNET</span>
            </p>
          </div>
          <Button isSecondary isDisabled={isPaid || disablePayment} value={intl.formatMessage({ id: 'payment.payNow' })} onButtonClick={onHandlePayment} />
        </PCardContainer> */}

        <PaymentDetail
          title={intl.formatMessage({ id: 'payment.bankTransferTitle' })}
          data={getBankDetails}
          isDisabled={isPaid}
        />

        <PCardContainer className="pcard-container--upload">
          {!proofOfTransfer ? (
            <>
              <Typography type="span" value={<strong>{intl.formatMessage({ id: 'proof.label' })}</strong>} />
              <Typography type="span" value={<small>{intl.formatMessage({ id: 'proof.note' })}</small>} />
              <input type="file" accept="image/*,.pdf" onChange={handleFileChange} className="upload-input" />
              <Button onButtonClick={handleSubmit} isDisabled={fileProof === null || fileProof === ''} isPrimary isSmall value={intl.formatMessage({ id: 'proof.upload' })} />
            </>
          ) : (
            <>
              <Typography type="span" value={<strong>{intl.formatMessage({ id: 'proof.label' })}</strong>} />
              <a style={{ display: 'block', margin: '10px 0 0 0' }} href={downloadLink} download="proofOfTransfer.png" rel="noreferrer">{intl.formatMessage({ id: 'proof.dl' })}</a>
            </>
          )}
        </PCardContainer>


        {showWarning ? (
          <Modal
            title={intl.formatMessage({ id: 'proof.warning.title' })}
            withPadding
            isWarning
            showModal={showWarning}
            onClose={() => {
              setShowWarning(false);
              history.push(PATH.PRINT_CHECKLIST);
            }}
          >
            <>
              {intl.formatMessage({ id: 'proof.warning.desc' })}
            </>
          </Modal>
        ) : null}
      </div>

      {footer}
    </PageContentWrapper>
  );
}

const mapStateToProps = state => ({
  token: selectors.getToken(state),
  // investedAmount: selectors.getInvestedAmount(state),
  investUnitToAmount: selectors.getInvestedUnitToAmount(state),
  product: selectors.getProduct(state),
  catalog: state.catalogueReducer?.data,
  isShowSubcription: selectors.isShowSubcription(state),
  applicantId: state.applicantRootReducer.applicantReducer.applicantId,
  proofOfTransfer: state.applicantRootReducer.applicantReducer.proofOfTransfer,
});

const mapDispatchToProps = dispatch => ({
  onUpdateCurrentStep: currentStep => dispatch(stepAction.updateCurrentStep(currentStep)),
  onGetStepsProgress: () => dispatch(stepAction.getProgress()),
  onGetCatalogue: () => dispatch(catalogueAction.fetchCatalogue()),
  onUpdateHistory: (code, codeI18n) => dispatch(applicantAction.updateHistory(code, codeI18n)),
  onSaveProofOfConcept: arg => dispatch(applicantAction.saveProofOfTransfer(arg)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithStepper(injectIntl(Payment)));
